module.exports = __webpack_public_path__ + "84a544eccb5994a2229c75e2faab14e4.svg";